import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Button, Space, Input, message, Table } from 'antd';
import FullHeightLayout from '../../components/FullHeightLayout';
import useWebPost from '../../utils/useWebPost';
import dayjs from 'dayjs';
import { exportToCSV, formatNumber } from '../../utils/functions';
import DateSelector from '../../components/DateSelector';
import renderFileList from '../../components/renderFileList';


// 格式化数据
const formatTableData = (list) => {
    return list.map(item => {
        // 1. 税率格式化
        let slText = item.sl;
        if (Number(item.sl) && item.sl > 0) {
            slText = `${item.sl}%`;
        } else {
            slText = <span className='gray'>{item.sl}</span>;
        }

        // 2. 不含税价
        const amountText = item.amount && item.amount > 0 ? formatNumber(item.amount) : '/';

        // 3. 税额
        const sjText = item.sj && item.sj > 0 ? formatNumber(item.sj) : '/';

        // 4. 开票金额合计
        const kpjText = item.kpj && item.kpj > 0 ? formatNumber(item.kpj) : '/';

        // 5. 附件（保持原来的 renderFileList 逻辑）
        const filesText = renderFileList(item.files1);

        // 返回新对象（不污染原数据）
        return {
            ...item,
            sl: slText,
            amount: amountText,
            sj: sjText,
            kpj: kpjText,
            files1: filesText,
        };
    });
};
function TjJxp() {
    const webPost = useWebPost();
    const [currentItem, setCurrentItem] = useState(null);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [modalVisible, setModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [myfilter, setMyfilter] = useState({});
    const [searchKeys, setSearchKeys] = useState({});

    const [mode, setMode] = useState('range');
    const [singleMonth, setSingleMonth] = useState(dayjs(new Date()));
    const [rangeMonths, setRangeMonths] = useState([dayjs(new Date('2025-03-01')), dayjs(new Date())]);
    const [sum, setSum] = useState(0);
    const [fkey, setFkey] = useState(0);
    const pageSizeOptions = [10, 20, 50, 100, 500, 1000, 2000];

    const [data2, setData2] = useState([]);
    const [data3, setData3] = useState([]);
    const [data4, setData4] = useState([]);
    const [box1, setBox1] = useState([]);
    const [box2, setBox2] = useState([]);
    const [dates, setDates] = useState({});

    useEffect(() => {
        fetchData(currentPage, pageSize);
        return undefined;
    }, [fkey]);

    const fetchData = async (page, limit) => {
        setLoading(true);
        const params = { ...dates, ...searchKeys, page, limit };
        try {
            const response = await webPost('tjJxpList', params);
            if (response) {
                // setData(response.mx);
                const formattedList = formatTableData(response.mx || []);
                setData(formattedList);
                setTotal(response.total)
                setData2(response.sum);
            }
        } catch (error) {
            console.error('获取列表失败:', error);
            message.error('请求失败，请稍后重试');
        } finally {
            setLoading(false);
        }
    };

    const lastProcessedRef = useRef('');

    useEffect(() => {
        if (!data?.mx || !Array.isArray(data.mx)) return;

        // 1. 生成当前参数的唯一哈希（避免重复处理同一批数据）
        const currentHash = JSON.stringify({
            mx: data.mx.map(it => it.km), // 只取km做标识，避免全量JSON过大
            box1,
            box2
        });

        // 2. 如果和上一次处理的哈希相同，直接返回，不重复处理
        if (lastProcessedRef.current === currentHash) {
            console.log('参数未变化，跳过重复处理');
            return;
        }

        // 3. 正常处理逻辑（和之前一致）
        console.log('原始mx长度：', data.mx.length);
        const mbx1 = [];
        const mbx2 = [];

        data.mx.forEach((it) => {
            if (box1.includes(it.km)) {
                mbx1.push(it);
                return;
            }
            if (box2.includes(it.km)) {
                mbx2.push(it);
                return;
            }
            if (!it.km?.includes("-1")) {
                mbx1.push(it);
                return;
            }
            mbx2.push(it);
        });

        console.log('处理后：mbx1=', mbx1.length, 'mbx2=', mbx2.length);
        setData3(mbx1);
        setData4(mbx2);

        // 4. 更新最后处理的哈希
        lastProcessedRef.current = currentHash;
    }, [data, box1, box2]);

    const refreshData = (p) => {
        setFkey(Math.random());
    }
    const openModal = (record) => {
        setCurrentItem(record);
        setModalVisible(true);
    };
    const handleModalClose = (v) => {
        setCurrentItem(null);
        setModalVisible(true);
        if (v) setFkey(Math.random());
    }
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };

    const [targetKeys, setTargetKeys] = useState([]);
    const transferDataSource = useMemo(() => {
        if (data?.mx && Array.isArray(data.mx)) {
            const uniqueKmMap = {};

            data.mx.forEach(item => {
                if (!uniqueKmMap[item.km]) {
                    uniqueKmMap[item.km] = {
                        key: item.km,
                        title: `${item.km} - ${item.kmmc}`,
                    };
                }
            });

            return Object.values(uniqueKmMap);
        } else {
            return [];
        }
    }, [data]);


    const columns = [
        { title: '编号', dataIndex: 'id', width: 58 },
        { title: '项目名称', dataIndex: 'xmmc', width: 160 },
        { title: '制单日期', dataIndex: 'ptime', width: 120 },
        { title: '合同名称（分包/采购合同）', dataIndex: 'mc', width: 160 },
        { title: '发票种类', dataIndex: 'zl', width: 80 },
        { title: '税率', dataIndex: 'sl', width: 90 },
        { title: '不含税价', dataIndex: 'amount', width: 160 },
        { title: '税额', dataIndex: 'sj', width: 140 },
        { title: '开票金额合计', dataIndex: 'kpj', width: 160 },
        { title: '票号', dataIndex: 'ph', width: 200 },
        { title: '是否抵扣', dataIndex: 'isdk', width: 120,render: (_)=> Number(_)===1?'√':'' },
        { title: '固定资产', dataIndex: 'isgdzc', width: 120,render: (_)=> Number(_)===1?'√':'' },
        { title: '说明', dataIndex: 'dk', width: 120 },
        { title: '数量', dataIndex: 'dknum', width: 120 },
        { title: '来款科目', dataIndex: 'kmmc', width: 140 },
        { title: '附件（凭证）', dataIndex: 'files1', width: 140 },
        { title: '备注', dataIndex: 'ps', width: 140 },
    ].filter(Boolean);
    return (
        <FullHeightLayout
            headerContent={
                <div style={{ position: 'relative', paddingBottom: 10, paddingRight: 120 }}>
                    <Space style={{ marginBottom: 16 }}>
                        <Space size='middle' style={{ marginTop: 8, marginRight: 16 }} wrap><DateSelector onChange={(v) => { setDates(v); console.log(v) }} /></Space>
                        <Space size='middle' style={{ marginTop: 8, marginRight: 16 }} wrap><Input value={setSearchKeys?.key1}
                            onChange={(e) => setSearchKeys((prev) => ({ ...prev, key1: e.target.value }))} placeholder='项目名称、客户' /></Space>
                        <Space size='middle' style={{ marginTop: 8, marginRight: 16 }} wrap>
                            <Input value={setSearchKeys?.key2} onChange={(e) => setSearchKeys((prev) => ({ ...prev, key2: e.target.value }))}
                                placeholder='业绩归属、参与/中标/自营' />
                        </Space>
                        <Space size='middle' style={{ marginTop: 8, marginRight: 16 }} wrap>
                            <Input value={setSearchKeys?.key3} onChange={(e) => setSearchKeys((prev) => ({ ...prev, key3: e.target.value }))}
                                placeholder='填报企业' />
                        </Space>
                        <Space size='middle' style={{ marginTop: 8, marginRight: 16 }} wrap>
                            <Button onClick={refreshData}>开始统计</Button>
                        </Space>
                        <Button style={{ margin: '0 10px', position: 'absolute', right: '10px', top: '10px' }} type="dashed" onClick={() => exportToCSV(data, columns.splice(1),
                            '进项票统计_' + (pageSize * (currentPage - 1) + '-' + pageSize * (currentPage)))}>
                            下载本页数据
                        </Button>
                    </Space>

                </div>
            }
            bodyContent={
                <Table dataSource={data} rowKey='id' bordered columns={columns}
                    tableLayout="fixed"
                    scroll={{
                        x: 1900,
                        y: 'calc(100vh - 360px)',
                    }}
                    pagination={{
                        current: currentPage,
                        pageSize,
                        total,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        onChange: (page, size) => {
                            setCurrentPage(page);
                            setPageSize(size);
                            fetchData(page, size);
                        },
                    }}
                />
            }
            footerContent={
                <div style={{
                    display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    税金合计：{data2.sj} ; 开票金额合计：{data2.kpj}
                </div>
            }
        />
    );
}



export default TjJxp;